<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_seeding_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="model.farm_id"
              @change="handleChange()"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.crop') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-crop"
              size="large"
              v-model="model.crop_id"
              @change="handleChange()"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in crops"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}:</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form required-date"
              v-model="model.date_save"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              @change="handleChange()"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <!-- <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.generate') }}
            </l-button> -->
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        v-if="showSowingCatch && !messageAlert"
      >
        <div class="mt-4 px-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered not-last-td table-data"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment_area_ha') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.remaining_area') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_area') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.variety') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_method') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.number_of_plants_h') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.harvest_date') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.observation') }}
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nSowing" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="width: 80px"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lot_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, i) in lots"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${i}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>

                    <td class="text-center">
                      <el-input
                        type="text"
                        style="min-width: 130px"
                        class="shadow-sm text-center"
                        :value="allotmentAreaById(model.lot_id[index - 1])"
                        disabled
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-input
                        type="text"
                        style="min-width: 130px"
                        class="shadow-sm text-center"
                        :value="
                          getRemainingLotArea(model.lot_id[index - 1])
                        "
                        disabled
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="0"
                        ref="area_sowing"
                        step="0.01"
                        style="min-width: 130px"
                        class="shadow-sm text-center mt-3 required-areas"
                        v-model.number="model.area_sowing[index - 1]"
                        name="sowing.area_row"
                        v-validate="modelValidations.area_sowing"
                        :error="getError('sowing.area_row', true, index)"
                        @change="
                          validateTotalSowingArea(
                            index - 1,
                            model.lot_id[index - 1]
                          )
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="width: 160px"
                        class="select-primary custom-width-select shadow-sm required-varieties"
                        size="large"
                        v-model="model.crop_variety_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                        @change="validateVariety(index - 1)"
                      >
                        <el-option
                          v-for="(option, v) in cropVariety"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="v + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="width: 160px"
                        class="select-primary custom-width-select shadow-sm required-sowing_method"
                        size="large"
                        v-model="model.sowing_method_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in sowingMethods"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="1"
                        style="min-width: 130px"
                        class="shadow-sm text-center mt-3 required-plant_number"
                        v-model.number="model.plant_number[index - 1]"
                        name="sowing.plant_number_row"
                        validate-event="modelValidations.plant_number"
                        :error="
                          getError('sowing.plant_number_row', true, index)
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <el-date-picker
                        v-if="renderComponent"
                        class="shadow-sm date-form required-dates"
                        style="min-width: 140px"
                        v-model="model.possible_harvest[index - 1]"
                        type="date"
                        :picker-options="pickerOptionsDetails"
                        value-format="yyyy-MM-dd"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                      </el-date-picker>
                    </td>
                    <td class="text-center">
                      <el-input
                        clearable
                        type="text-area"
                        class="shadow-sm"
                        style="width: 130px"
                        v-model="model.observation[index - 1]"
                      >
                      </el-input>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="display: table-cell"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nSowing++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nSowing > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <!-- <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateDetail()"
              >
                {{ $t('common_words.save') }}
              </l-button> -->
              <button
                class="btn btn-success custom-shadow-btn btn-filter m-4"
                @click="validateDetail()"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <!-- <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </l-button> -->
              <button
                class="btn btn-danger custom-shadow-btn btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </button>
            </div>
          </div>
        </div>
      </card>
      <br />
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { resetObjectProperties } from 'src/util/Util.js';
import i18n from 'src/i18n';
import Lot from 'src/class/farms/Lot';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        farm_id: null,
        crop_id: null,
        date_save: null,
        lot_id: [],
        sowing_method_id: [],
        crop_variety_id: [],
        plant_number: [],
        area_sowing: [],
        possible_harvest: [],
        observation: [],
        nSowing: 1,
        detailsId: [],
      },
      modelValidations: {
        area_sowing: {
          required: true,
          min_value: 0,
        },
        plant_number: {
          required: true,
          min_value: 1,
        },
      },
      showSowingCatch: null,
      messageAlert: null,
      // noReiamingArea: [],
      // noReiamingAreaDuplicated: [],
      farms: [],
      crops: [],
      lots: [],
      sowingMethods: [],
      cropVariety: [],
      lotArea: [],
      // sowingCatchDetail: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptionsDetails: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  mixins: [MixinNotification, MixinMasters, MixinPermissions, MixinForm],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    hasDuplicates(lotIdArray) {
      const duplicates = lotIdArray.filter(
        (item, index) => lotIdArray.indexOf(item) !== index
      );
      return duplicates.length > 0;
    },
    handleChange() {
      this.showSowingCatch = false;
    },
    allotmentAreaById(lotId) {
      const lot = new Lot(this.lots);

      return lot.getAllotmentAreaById(lotId);
    },
    getRemainingLotArea(lotId) {
      if (lotId in this.lotArea) {
        return this.lotArea[lotId].typed_remaining_area;
      } else {
        return this.allotmentAreaById(lotId);
      }
    },
    getOldRemainingArea(lotId) {
      if (lotId in this.lotArea) {
        return this.lotArea[lotId].typed_remaining_area;
      } else {
        return null;
      }
    },
    handleDelete(index) {
      this.model.lot_id.splice(index, 1);
      this.model.detailsId.splice(index, 1);
      this.model.area_sowing.splice(index, 1);
      this.model.sowing_method_id.splice(index, 1);
      this.model.crop_variety_id.splice(index, 1);
      this.model.plant_number.splice(index, 1);
      this.model.possible_harvest.splice(index, 1);
      this.model.observation.splice(index, 1);
      this.model.nSowing--;
    },

    validateVariety(index) {
      const selectedVariety = this.model.crop_variety_id[index];
      const selectedLot = this.model.lot_id[index];
      this.model.lot_id.filter((lot, lotIndex) => {
        if (
          lot === selectedLot &&
          index !== lotIndex &&
          this.model.crop_variety_id[lotIndex] === selectedVariety
        ) {
          SweetAlert.warning(i18n.t('sweet_alert.sowing.message_variety'));
          this.model.crop_variety_id[index] = null;
        }
      });
    },

    validateTotalSowingArea(index, lotId) {
      const lot = new Lot(this.lots);
      const lotArea = lot.getAllotmentAreaById(lotId);
      if (isset(this.lotArea)) {
        // const remainingArea = this.lotArea[lotId].typed_remaining_area;
        let oldRemainingArea = this.getOldRemainingArea(lotId);
        const typedArea = this.model.area_sowing[index];
        const totalTypedArea = this.model.lot_id
          .map((lot, lotIndex) => {
            if (Number(lot) === Number(lotId)) {
              return this.model.area_sowing[lotIndex];
            } else return 0;
          })
          .reduce((prev, curr) => prev + curr, 0);

        if (isset(oldRemainingArea)) {
        
          if (totalTypedArea > lotArea) {
            SweetAlert.warning(i18n.t('sweet_alert.sowing.message_area'));
            if (this.lotArea[lotId].area_sowing) {

              if (this.hasDuplicates(this.model.lot_id)) {
                const totalTypedAreaValidate = this.model.lot_id
                  .map((lot, lotIndex) => {
                    if (Number(lot) === Number(lotId)) {
                      const area = Number(this.model.area_sowing[lotIndex]);
                      if (isNaN(area)) {
                        return 0; 
                      }
                      return area;
                    } else return 0;
                  })
                  .reduce((prev, curr) => 
                  {
                    if (prev + curr > lotArea) {
                      return prev;
                    }else {
                     return prev + curr
                    }
                  }, 
                  0);

                oldRemainingArea = (Number(lotArea) - Number(totalTypedAreaValidate)).toFixed(2);
                this.$set(this.model.area_sowing, index, 0);
              }else {
                this.$set(
                this.model.area_sowing,
                index,
                this.lotArea[lotId].area_sowing
                );
              }
             
            }else {
              this.$set(this.model.area_sowing, index, 0);
            }
          } else if (this.hasDuplicates(this.model.lot_id)){
             oldRemainingArea = (Number(lotArea) - Number(totalTypedArea)).toFixed(2); 
          }
          else {
            // TODO: agregar una validacion del typeArea para que no se buguee visualmente la ultima oldRemaining con un valor mayor al area
              oldRemainingArea = (Number(lotArea) - Number(typedArea)).toFixed(2);
            }
          this.$set(this.lotArea, lotId, {
            ...this.lotArea[lotId],
            typed_remaining_area: oldRemainingArea,
          });
        } else {

          if (this.hasDuplicates(this.model.lot_id)) {
            const totalWriteArea = this.model.lot_id
              .map((lot, lotIndex) => {
                if (Number(lot) === Number(lotId)) {
                  return this.model.area_sowing[lotIndex];
                } else return 0;
              })
              .reduce((prev, curr) => prev + curr, 0);

            if (totalWriteArea > lotArea) {
              SweetAlert.warning(i18n.t('sweet_alert.sowing.message_area'));
              this.$set(this.model.area_sowing, index, 0);
            }
          }
        }
      } else {

        if (this.hasDuplicates(this.model.lot_id)) {
          const totalWriteArea = this.model.lot_id
            .map((lot, lotIndex) => {
              if (Number(lot) === Number(lotId)) {
                return this.model.area_sowing[lotIndex];
              } else return 0;
            })
            .reduce((prev, curr) => prev + curr, 0);

          if (totalWriteArea > lotArea) {
            SweetAlert.warning(i18n.t('sweet_alert.sowing.message_area'));
            this.$set(this.model.area_sowing, index, 0);
          }
        }
      }
    },

    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.nSowing = 1;
      this.model = {
        ...resetObjectProperties(this.model, [
          'farm_id',
          'crop_id',
          'date_save',
          'nSowing',
        ]),
      };
    },

    confirmDelete() {
      if (this.model.id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.sowing.selected_sowing_capture')
        ).then((result) => {
          if (result.value) this.deleteSowingCatch();
        });
      } else this.cleanForm();
    },

    deleteSowingCatch() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'seeding/sowingcatchs';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showSowingCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.sowing.sowing_capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    validate() {
      if (!isset(this.model.farm_id))
        return this.validationInputsRequired('farm');
      else if (!isset(this.model.crop_id))
        return this.validationInputsRequired('crop');
      else if (!isset(this.model.date_save))
        return this.validationInputsRequired('date');
      else {
        this.cleanForm();
        this.loadData();
      }
    },

    validateDetail() {
      if (!isset(this.model.lot_id))
        return this.validationInputsRequired('lots');
      else if (!isset(this.model.crop_variety_id))
        return this.validationInputsRequired('varieties');
      else if (!isset(this.model.sowing_method_id))
        return this.validationInputsRequired('sowing_method');
      else if (!isset(this.model.possible_harvest))
        return this.validationInputsRequired('dates');
      else if (this.model.area_sowing.length === 0)
        return this.validationInputsRequired('areas');
      else if (this.model.plant_number.length === 0)
        return this.validationInputsRequired('plant_number');
      this.storeUpdateSowingCatchs();
    },

    storeUpdateSowingCatchs() {
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'seeding/sowingcatchs';

        if (this.model.id) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              console.log(this.model);
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    loadData() {
      this.showHideLoading(true);
      let data = {
        farm_id: this.model.farm_id,
        crop_id: this.model.crop_id,
        date_save: this.model.date_save,
      };

      this.showSowingCatch = false;

      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.model.farm_id),
        Axios.postMasters({ ...data, route: 'seeding/sowing/catchs' }),
        Axios.postMasters({ ...data, route: 'seeding/lot/area' }),
      ])
        .then((response) => {
          const [responseLots, responseSowingCatch, responseLotArea] = response;
          this.lots = responseLots.data.data;
          const sowingCatch = responseSowingCatch.data.data;
          // this.sowingCatchDetail = sowingCatch[0].sowing_catch_details;
          this.lotArea = responseLotArea.data.data;
          if (sowingCatch['closing']) {
            this.messageAlert = {
              show: true,
              message: sowingCatch['closing'].message,
            };
            delete sowingCatch['closing'];
          } else this.messageAlert = null;

          if (isset(sowingCatch)) {
            this.model.id = sowingCatch[0].id;
            this.model.nSowing = sowingCatch[0].sowing_catch_details.length
              ? sowingCatch[0].sowing_catch_details.length
              : 1;
            const lotSelecteds = [];

            sowingCatch[0].sowing_catch_details.forEach((detail) => {
              lotSelecteds.push(detail.lot_id);
              // this.model.detailsId.push(detail.lot_id);
              // this.model.detailsId.push(detail.detailsId);
              this.model.detailsId.push(detail.id);
              this.model.sowing_method_id.push(detail.sowing_method_id);
              this.model.crop_variety_id.push(detail.crop_variety_id);
              this.model.plant_number.push(detail.plant_number);
              this.model.area_sowing.push(detail.area_sowing);
              this.model.possible_harvest.push(detail.possible_harvest);
              this.model.observation.push(detail.observation);
            });
            try {
              this.model.lot_id = [];
              setTimeout(() => {
                this.model.lot_id = [...lotSelecteds];
              }, 5);
              
              this.showSowingCatch = true;
            } catch (error) {}
          } else {
            this.showSowingCatch = true;
            this.cleanForm();
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('farms/crops'),
        Axios.getMasters('seeding/sowingmethods/field'),
        Axios.getMasters('cropvarieties'),
      ])
        .then((response) => {
          const [
            responseFarm,
            responseCrop,
            responseSowingMethod,
            responseCropVariety,
          ] = response;
          this.farms = responseFarm.data.data;
          this.crops = responseCrop.data.data;
          this.sowingMethods = responseSowingMethod.data.data;
          this.cropVariety = responseCropVariety.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style scoped>
.table-responsive {
  overflow-x: auto !important;
}
</style>
